
        import type { TemplateResult, TemplateRootPropsForTag } from 'Components/types';
type differentialDialogRTRootProps = TemplateRootPropsForTag<'div'>;
import { createElement as _createElement } from 'preact';
import { map as _map } from 'Utils/array';
import _translate from 'Utils/translate';
export default function differentialDialogRT(): TemplateResult<differentialDialogRTRootProps> {
    return _createElement('div', { 'className': 'dialog-container' }, _createElement('div', { 'className': 'dialog-content' }, _createElement('div', { 'className': 'dialog-header' }, _createElement('div', { 'className': 'dialog-title' }, 'Select Your Differential'), _createElement('div', {
        'className': 'close',
        'onClick': this.close
    }, _createElement('svg', {
        'width': '26',
        'height': '26',
        'viewBox': '0 0 26 26',
        'fill': 'none',
        'xmlns': 'http://www.w3.org/2000/svg'
    }, _createElement('path', {
        'd': 'M5.00005 5L21.0001 21M21.0001 5L14.7778 11.2222M11.2222 14.7778L5 21.0001',
        'stroke': '#231F20',
        'strokeWidth': '1.5',
        'strokeLinecap': 'round'
    })))), _createElement('div', { 'className': 'dialog-body' }, [this.vehicleWidget(function () {
            function repeatSelects1(selects, selectsIndex) {
                return [selects(function () {
                        function repeatField1(entry, index, differentialInfo, field, fieldIndex) {
                            return [differentialInfo[field] ? _createElement('div', {
                                    'className': 'cm_dropdown_info-item',
                                    'key': '12291'
                                }, _createElement('div', { 'className': 'cm_dropdown_info-title' }, field), _createElement('div', { 'className': 'cm_dropdown_info-value' }, differentialInfo[field])) : null];
                        }
                        function scopeDifferentialInfo2(entry, index) {
                            var differentialInfo = JSON.parse(entry?.payload)?.[0];
                            return _createElement('div', {
                                'className': 'option' + (this.isSearchable && this.activeIndex === index || !this.isSearchable && entry.selected ? ' cm_checked' : ''),
                                'key': entry.value
                            }, _createElement('div', { 'className': 'cm_dropdown_header' }, _createElement('img', {
                                'className': 'cm_dropdown_image',
                                'src': differentialInfo?.ImageUrl || window.Convermax.config.noImageSrc,
                                'alt': entry.value + ' image'
                            }), _createElement('div', { 'className': 'cm_dropdown_value fs-sm fw-semibold lh-1_35 mt-2 mb-4' }, entry.value)), differentialInfo ? _createElement.apply(this, [
                                'div',
                                {
                                    'className': 'cm_dropdown_info',
                                    'key': '1163'
                                },
                                _map(Object.keys(differentialInfo).filter(f => f !== 'ImageUrl' && f !== 'Description'), repeatField1.bind(this, entry, index, differentialInfo))
                            ]) : null, _createElement('div', {
                                'onClick': () => {
                                    this.onChange(entry.term);
                                },
                                'className': 'cm_vehicle-widget_button cm_vehicle-widget_button__go btn btn-primary'
                            }, '\n          ', entry.selected ? 'Selected' : 'Select', '\n        '));
                        }
                        function repeatEntry3(entry, index, differentialInfo) {
                            return scopeDifferentialInfo2.apply(this, [
                                entry,
                                index
                            ]);
                        }
                        return this.field === 'Differential' ? _createElement('div', {
                            'className': this.extraClassName,
                            'key': '0'
                        }, !this.isSearchable ? _createElement('div', {
                            'className': 'cm_select_toggle cm_toggle-dropdown',
                            'key': '87'
                        }, _createElement.apply(this, [
                            'div',
                            {
                                'className': 'cm_dropdown cm_select_dropdown',
                                'aria-label': this.title
                            },
                            !this.hideNullOption ? _createElement('div', {
                                'className': 'option',
                                'key': 'null-option',
                                'onClick': () => this.onChange('')
                            }, '\n        ', _translate(`select_title`), ' ', this.title, '\n      ') : null,
                            this.loading ? _createElement('div', {
                                'className': 'option',
                                'key': 'null-option',
                                'disabled': true
                            }, _translate(`select_loading`)) : null,
                            !this.loading ? _map(this.entries, repeatEntry3.bind(this)) : null
                        ])) : null) : null;
                    }, { count: undefined })];
            }
            return _createElement('div', { 'className': 'cm_DialogVehicleWidget_differential cm_vehicle-widget cm_vehicle-widget__dialog cm_vehicle-widget__differential cm_vehicleWidget' }, _createElement('div', { 'className': 'cm_vehicle-widget__header-container' }, _createElement('div', { 'className': 'cm_vehicle-widget__label-container' }, _createElement('div', { 'className': 'cm_vehicle-widget__subtitle' }, 'Currently Shopping For:'), _createElement('div', { 'className': 'cm_vehicle-widget__label' }, '\n              ', window.Convermax.getVehicleLabelWithoutDifferential(this.vehicle), '\n            ')), _createElement('div', {
                'className': 'differential-tooltip-trigger',
                'onClick': e => window.Convermax.showToggleTooltip(e)
            }, '\n            How do I choose?\n          '), [_createElement('div', {
                    'className': 'cm_hide differential-tooltip',
                    'key': '6800'
                }, _createElement('div', { 'className': 'differential-tooltip-content' }, _createElement('div', {
                    'className': 'close',
                    'onClick': window.Convermax.hideTooltip
                }, _createElement('svg', {
                    'width': '26',
                    'height': '26',
                    'viewBox': '0 0 26 26',
                    'fill': 'none',
                    'xmlns': 'http://www.w3.org/2000/svg'
                }, _createElement('path', {
                    'd': 'M5.00005 5L21.0001 21M21.0001 5L14.7778 11.2222M11.2222 14.7778L5 21.0001',
                    'stroke': '#231F20',
                    'strokeWidth': '1.5',
                    'strokeLinecap': 'round'
                }))), _createElement('div', { 'className': 'differential-tooltip-body' }, _createElement('p', {}, '\n        Please follow the below steps and compare your results to the stats listed on the diff selection\n        window.\n      '), _createElement('ul', {}, _createElement('li', {}, _createElement('strong', {}, 'Tip 1:'), ' Determine differential location to be worked on: Front or Rear'), _createElement('li', {}, _createElement('strong', {}, 'Tip 2:'), ' Count Cover Bolts'), _createElement('li', {}, _createElement('strong', {}, 'Tip 3:'), ' Measure Ring Gear Diameter'), _createElement('li', {}, _createElement('strong', {}, 'Tip 4:\xA0'), ' Count Splines')), _createElement('p', {}, 'Still need help? Start a live chat with\xA0', _createElement('a', { 'href': '/pages/contact' }, 'tech support!')))))]), _createElement('div', { 'className': 'cm_vehicle-widget_dropdowns' }, _createElement('div', { 'className': 'cm_vehicle-widget_body' }, _createElement.apply(this, [
                'div',
                { 'className': 'cm_vehicle-widget_select-container  cmRepeater_selects' },
                _map(this.selects, repeatSelects1.bind(this))
            ])), _createElement('div', {
                'className': 'cm_vehicle-widget_button cm_vehicle-widget_button__go btn btn-primary',
                'onClick': this.selectVehicle,
                'disabled': !this.allowToSetVehicle,
                'role': 'button',
                'tabIndex': this.allowToSetVehicle ? '0' : '-1'
            }, '\n            Shop with Selected Differential\n          ')));
        }, {
            widgetName: 'undefined',
            items: undefined
        })])));
}
        export const componentNames = ["cm:vehicleWidget"]